<template>
    <div class="tsa-digitalCertificateAgreement" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>数字证书服务协议</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div id="tsaPdfContainer2"></div>
            </div>
            <div class="bottom">
                <div class="btn" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" :class="{ disabled: confirmDisabled }" @click="confirm">
                    <p>{{ btnText }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Pdfh5 from "pdfh5";
import 'pdfh5/css/pdfh5.css'
import { default as domain } from '../../js/domain.js';
import { Toast } from 'mint-ui';
import { signPasswordStatusApi, signAgreementViewApi, signAgreementAgreeApi } from '@/api/common';
import { setBodyOverflow } from '@/js/utils';
export default {
    name: 'TsaDigitalCertificateAgreement',
    data () {
        return {
            show: false,
            url: '',
            countdown: 10,
            timer: null,
            contractId: '',
            signSessionId: '',
            verificationId: '',
        }
    },
    computed: {
        confirmDisabled () {
            return this.countdown > 0
        },
        btnText () {
            return this.confirmDisabled ? `我已阅读并同意（${this.countdown}s）` : '我已阅读并同意'
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (val) {
                this.countdown = process.env.NODE_ENV === 'development' ? 1 : 10
                this.pdfh5 = new Pdfh5("#tsaPdfContainer2", {
                    pdfurl: this.url
                });
                this.timer = setInterval(() => {
                    this.countdown--
                    if (this.countdown <= 0) {
                        clearInterval(this.timer)
                        this.timer = null
                    }
                }, 1000)
            } else {
                if (this.timer) {
                    clearInterval(this.timer)
                    this.timer = null
                }
                this.pdfh5 && this.pdfh5.destroy()
                this.pdfh5 = null
                this.contractId = ''
                this.signSessionId = ''
                this.verificationId = ''
            }
        }
    },
    beforeDestroy () {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    },
    methods: {
        init () {
            this.$http.get(domain('_policyDefault'),
            {
                params: {
                    verificationId: this.verificationId
                }
        }).then((res) => {
                this.show = true
                this.url = res.body.policyUrl
                this.certPlatformType = res.body.value
                this.policyReadAt = res.body.policyReadAt
                this.$TsaLoading.show()
                signAgreementViewApi({
                    contractId: this.contractId,
                    signSessionId: this.signSessionId,
                    verificationId: this.verificationId,
                }).then((res) => {
                    this.$TsaLoading.hide()
                    if (res.code == '0') {
                        
                    } else {
                        this.show = false
                    }
                }).catch(() => {
                    this.$TsaLoading.hide()
                })
            }).catch((err) => {
                console.error('Failed to fetch policy:', err)
                this.$toast('系统异常')
            })
        },
        close () {
            this.show = false
        },
        confirm () {
            if (this.confirmDisabled) return
            this.show = false
            this.$TsaLoading.show()
            signAgreementAgreeApi({
                contractId: this.contractId,
                signSessionId: this.signSessionId,
                verificationId: this.verificationId,
                certPlatformType: this.certPlatformType,
                policyReadAt: this.policyReadAt
            }).then((res) => {
                if (res.code == '0') {
                    let userCertificateAgreementId = res.data.userCertificateAgreementId
                    signPasswordStatusApi().then((res) => {
                        this.$TsaLoading.hide()
                        if (res.code == '0') {
                            let resData = res.data || {}
                            this.onConfirm && this.onConfirm({
                                ...resData,
                                userCertificateAgreementId,
                                certPlatformType: this.certPlatformType,
                            })
                        }
                    }).catch(() => {
                        this.$TsaLoading.hide()
                    })
                } else {
                    this.$TsaLoading.hide()
                }
            }).catch(() => {
                this.$TsaLoading.hide()
            })
            
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-digitalCertificateAgreement {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 90%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 24px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow: hidden;
                padding: 0 4px;
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    width: 92px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    flex: 1;
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                    &.disabled {
                        background: #D9D9D9;
                        cursor: not-allowed;
                        p {
                            color: #999999;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/digitalCertificateAgreement/index.vue